import * as React from 'react';
import React__default, { useContext, useCallback, createContext, useRef, useEffect, Component, createRef, useState } from 'react';
import { fabric } from 'fabric';
import { Box } from '@oneboard/ui-components';
import PropTypes from 'prop-types';
import { useMachine } from '@xstate/react';
import { assign, createMachine } from 'xstate';
import { CNode, RoomConsumer, PlayerConsumer, autorun, createPlugins, DeviceType, WhiteWebSdk, DefaultHotKeys } from 'white-react-sdk';
import { CursorTool } from '@netless/cursor-tool';
import { isIOS, isMacOs, isSafari, osName } from 'react-device-detect';
import styled from 'styled-components';
import { IframeBridge, IframeWrapper } from '@oneboard/iframe-bridge';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$5() {
  _extends$5 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$5.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _isPlaceholder(a) {
  return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}

/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */

function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}

/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */

function _curry2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;

      case 1:
        return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
          return fn(a, _b);
        });

      default:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
          return fn(_a, b);
        }) : _isPlaceholder(b) ? _curry1(function (_b) {
          return fn(a, _b);
        }) : fn(a, b);
    }
  };
}

/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */

function _curry3(fn) {
  return function f3(a, b, c) {
    switch (arguments.length) {
      case 0:
        return f3;

      case 1:
        return _isPlaceholder(a) ? f3 : _curry2(function (_b, _c) {
          return fn(a, _b, _c);
        });

      case 2:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function (_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder(b) ? _curry2(function (_b, _c) {
          return fn(a, _b, _c);
        }) : _curry1(function (_c) {
          return fn(a, b, _c);
        });

      default:
        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function (_a, _b) {
          return fn(_a, _b, c);
        }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function (_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function (_b, _c) {
          return fn(a, _b, _c);
        }) : _isPlaceholder(a) ? _curry1(function (_a) {
          return fn(_a, b, c);
        }) : _isPlaceholder(b) ? _curry1(function (_b) {
          return fn(a, _b, c);
        }) : _isPlaceholder(c) ? _curry1(function (_c) {
          return fn(a, b, _c);
        }) : fn(a, b, c);
    }
  };
}

/**
 * Inserts the sub-list into the list, at the specified `index`. _Note that this is not
 * destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig Number -> [a] -> [a] -> [a]
 * @param {Number} index The position to insert the sub-list
 * @param {Array} elts The sub-list to insert into the Array
 * @param {Array} list The list to insert the sub-list into
 * @return {Array} A new Array with `elts` inserted starting at `index`.
 * @example
 *
 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
 */

var insertAll = /*#__PURE__*/_curry3(function insertAll(idx, elts, list) {
  idx = idx < list.length && idx >= 0 ? idx : list.length;
  return [].concat(Array.prototype.slice.call(list, 0, idx), elts, Array.prototype.slice.call(list, idx));
});

var insertAll$1 = insertAll;

var _ActionTypes, _on2, _states, _states2;
var States = {
  Uninitialized: 'Uninitialized',
  Initialized: 'Initialized',
  Drawing: 'Drawing',
  Idle: 'Idle',
  Selecting: 'Selecting',
  Erasing: 'Erasing',
  LoadingTeachingMaterials: 'LoadingTeachingMaterials'
};
var ActionTypes = (_ActionTypes = {
  Initial: 'Initial',
  Mouse: 'Mouse',
  Select: 'Select',
  Erase: 'Erase',
  Draw: 'Draw',
  EraseAll: 'EraseAll',
  InsertImage: 'InsertImage',
  SetPageIndex: 'SetPageIndex',
  ToggleTeachingMaterial: 'ToggleTeachingMaterial',
  CreateNewPages: 'CreateNewPages'
}, _defineProperty(_ActionTypes, "SetPageIndex", 'SetPageIndex'), _defineProperty(_ActionTypes, "LoadTeachingMaterials", 'LoadTeachingMaterials'), _defineProperty(_ActionTypes, "Previous", 'Previous'), _defineProperty(_ActionTypes, "ToggleChatRoom", 'ToggleChatRoom'), _ActionTypes);
var assignCanvas = assign({
  canvas: function canvas(ctx, event) {
    return event.payload.canvas;
  }
});

var setDrawingMode = function setDrawingMode(ctx) {
  var canvas = ctx.canvas;
  canvas.isDrawingMode = true;
  canvas.freeDrawingBrush.color = '#F44336';
};

var setSelectingMode = function setSelectingMode(ctx) {
  var canvas = ctx.canvas;
  canvas.isDrawingMode = false;
  canvas.selection = true;
  canvas.forEachObject(function (obj) {
    obj.selectable = true;
    obj.hoverCursor = 'move';
  });
};

var disabledSelect = function disabledSelect(ctx, event) {
  var canvas = ctx.canvas;
  canvas.discardActiveObject();
  canvas.selection = false;
  canvas.forEachObject(function (obj) {
    obj.selectable = false;
    obj.hoverCursor = 'default';
  });
};

function eraseActiveObjects(canvas) {
  return function (opt) {
    canvas.getActiveObjects().forEach(function (obj) {
      canvas.remove(obj);
    });
    canvas.discardActiveObject().renderAll();
  };
}

var startErasingMode = function startErasingMode(ctx, event) {
  var canvas = ctx.canvas;
  canvas.on('selection:created', eraseActiveObjects(canvas));
};

var leaveErasingMode = function leaveErasingMode(ctx, event) {
  var canvas = ctx.canvas;
  canvas.off('selection:created');
};

var clearCanvas = function clearCanvas(ctx) {
  var canvas = ctx.canvas;
  canvas.clear();
};

var insertImage = function insertImage(ctx, evt) {
  var canvas = ctx.canvas;
  var data = evt.payload.data;
  fabric.Image.fromURL(data, function (img) {
    canvas.add(img);
    canvas.centerObject(img);
    img.setCoords();
    canvas.renderAll();
  });
};

var createNewPages = assign({
  annotations: function annotations(ctx, evt) {
    var _evt$payload;

    var annotations = ctx.annotations,
        pageIndex = ctx.pageIndex;
    var pageCount = ((_evt$payload = evt.payload) === null || _evt$payload === void 0 ? void 0 : _evt$payload.pageCount) || 1;
    var newAnnotations = Array.from(new Array(pageCount), function () {
      return new fabric.Canvas().toJSON();
    });
    return insertAll$1(pageIndex, newAnnotations, annotations);
  }
});
var saveCurrentAnnotations = assign({
  annotations: function annotations(ctx, evt) {
    var pageIndex = ctx.pageIndex,
        annotations = ctx.annotations,
        canvas = ctx.canvas;

    var newAnnotations = _toConsumableArray(annotations);

    newAnnotations[pageIndex] = canvas.toJSON();
    return newAnnotations;
  }
});

var loadCurrentAnnotation = function loadCurrentAnnotation(ctx, evt) {
  var canvas = ctx.canvas,
      pageIndex = ctx.pageIndex,
      annotations = ctx.annotations;
  var annotation = annotations[pageIndex];
  canvas.loadFromJSON(annotation, canvas.renderAll.bind(canvas));
};

var setPageIndexHandler = assign({
  pageIndex: function pageIndex(ctx, evt) {
    var annotations = ctx.annotations;
    var pageIndex = evt.payload.pageIndex;
    var minPageIndex = 0;
    var maxPageIndex = annotations.length - 1;
    return Math.max(minPageIndex, Math.min(pageIndex, maxPageIndex));
  }
});
var setTeachingMaterialStateHandler = assign({
  teachingMaterialState: function teachingMaterialState(ctx, evt) {
    var teachingMaterialState = evt.payload.teachingMaterialState;
    return teachingMaterialState;
  }
});

var loadTeachingMaterialImage = function loadTeachingMaterialImage(url) {
  return new Promise(function (resolve, reject) {
    fabric.Image.fromURL(url, function (img) {
      resolve(img);
    });
  });
};

var createTeachingMaterials = assign({
  annotations: function annotations(ctx, evt) {
    var canvas = ctx.canvas,
        annotations = ctx.annotations,
        pageIndex = ctx.pageIndex;
    var newAnnotations = evt.data.map(function (img) {
      var isCanvasWidthwise = canvas.width > canvas.height; // const isImageWidthwise = img.width > img.height;

      var getScaleRatio = function getScaleRatio() {
        if (isCanvasWidthwise) {
          if (canvas.height > img.height) {
            return img.height / canvas.height;
          }

          return canvas.height / img.height;
        }

        if (canvas.width > img.width) {
          return img.width / canvas.width;
        }

        return canvas.width / img.width;
      };

      var scale = getScaleRatio();
      return new fabric.Canvas().setBackgroundImage(img, null, {
        top: canvas.height * 0.5 - img.height * scale * 0.5,
        left: canvas.width * 0.5 - img.width * scale * 0.5,
        scaleX: scale,
        scaleY: scale
      }).toJSON();
    });
    return insertAll$1(pageIndex + 1, newAnnotations, annotations);
  }
});
var goNextPage = assign({
  pageIndex: function pageIndex(ctx) {
    return ctx.pageIndex + 1;
  }
});
var setChatRoomStateHandler = assign({
  chatRoomState: function chatRoomState(ctx, evt) {
    var chatRoomState = evt.payload.chatRoomState;
    return chatRoomState;
  }
});
var machine = createMachine({
  id: 'canvasMachine',
  initial: States.Uninitialized,
  context: {
    canvas: null,
    annotations: [],
    pageIndex: 0,
    teachingMaterialState: false,
    chatRoomState: false
  },
  states: (_states2 = {}, _defineProperty(_states2, States.Uninitialized, {
    on: _defineProperty({}, ActionTypes.Initial, {
      actions: assignCanvas,
      target: States.Initialized
    })
  }), _defineProperty(_states2, States.Initialized, {
    initial: "".concat(States.Idle),
    entry: createNewPages,
    on: (_on2 = {}, _defineProperty(_on2, ActionTypes.Select, ".".concat(States.Selecting)), _defineProperty(_on2, ActionTypes.Mouse, ".".concat(States.Idle)), _defineProperty(_on2, ActionTypes.Draw, ".".concat(States.Drawing)), _defineProperty(_on2, ActionTypes.Erase, ".".concat(States.Erasing)), _defineProperty(_on2, ActionTypes.EraseAll, {
      actions: clearCanvas
    }), _defineProperty(_on2, ActionTypes.InsertImage, {
      actions: insertImage
    }), _defineProperty(_on2, ActionTypes.CreateNewPages, {
      actions: [saveCurrentAnnotations, goNextPage, createNewPages, loadCurrentAnnotation]
    }), _defineProperty(_on2, ActionTypes.SetPageIndex, {
      actions: [saveCurrentAnnotations, setPageIndexHandler, loadCurrentAnnotation]
    }), _defineProperty(_on2, ActionTypes.LoadTeachingMaterials, {
      target: ".".concat(States.LoadingTeachingMaterials),
      actions: saveCurrentAnnotations
    }), _defineProperty(_on2, ActionTypes.ToggleTeachingMaterial, {
      actions: setTeachingMaterialStateHandler
    }), _defineProperty(_on2, ActionTypes.ToggleChatRoom, {
      actions: setChatRoomStateHandler
    }), _on2),
    states: (_states = {}, _defineProperty(_states, States.Idle, {
      entry: disabledSelect,
      exit: setSelectingMode
    }), _defineProperty(_states, States.Selecting, {
      entry: setSelectingMode
    }), _defineProperty(_states, States.Drawing, {
      entry: setDrawingMode,
      exit: setSelectingMode
    }), _defineProperty(_states, States.Erasing, {
      entry: startErasingMode,
      exit: leaveErasingMode
    }), _defineProperty(_states, States.LoadingTeachingMaterials, {
      invoke: {
        src: function () {
          var _src = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(ctx, evt) {
            var materials;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    materials = evt.payload.materials;
                    _context.next = 3;
                    return Promise.all(materials.map(loadTeachingMaterialImage));

                  case 3:
                    return _context.abrupt("return", _context.sent);

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function src(_x, _x2) {
            return _src.apply(this, arguments);
          }

          return src;
        }(),
        onDone: {
          target: States.Previous,
          actions: [createTeachingMaterials, goNextPage, loadCurrentAnnotation]
        }
      }
    }), _defineProperty(_states, States.Previous, {
      type: 'history'
    }), _states)
  }), _states2)
});

var StateContext = /*#__PURE__*/createContext();
var DispatchContext = /*#__PURE__*/createContext(function () {});
var CanvasProvider = function CanvasProvider(_ref) {
  var children = _ref.children;

  var _useMachine = useMachine(machine),
      _useMachine2 = _slicedToArray(_useMachine, 2),
      state = _useMachine2[0],
      send = _useMachine2[1];

  return /*#__PURE__*/React__default.createElement(StateContext.Provider, {
    value: state
  }, /*#__PURE__*/React__default.createElement(DispatchContext.Provider, {
    value: send
  }, children));
};
var useCanvasState = function useCanvasState() {
  return useContext(StateContext);
};
var useCanvasDispatch = function useCanvasDispatch() {
  var dispatch = useContext(DispatchContext);
  var initial = useCallback(function (canvas) {
    dispatch({
      type: ActionTypes.Initial,
      payload: {
        canvas: canvas
      }
    });
  }, []);
  var mouse = useCallback(function () {
    dispatch({
      type: ActionTypes.Mouse
    });
  }, []);
  var draw = useCallback(function () {
    dispatch({
      type: ActionTypes.Draw
    });
  }, []);
  var select = useCallback(function () {
    dispatch({
      type: ActionTypes.Select
    });
  }, []);
  var eraser = useCallback(function () {
    dispatch({
      type: ActionTypes.Erase
    });
  }, []);
  var eraseAll = useCallback(function () {
    dispatch({
      type: ActionTypes.EraseAll
    });
  }, []);
  var insertImage = useCallback(function (inputEvent) {
    var files = inputEvent.target.files;
    var reader = new FileReader();

    reader.onload = function (file) {
      var data = file.target.result;
      dispatch({
        type: ActionTypes.InsertImage,
        payload: {
          data: data
        }
      });
      inputEvent.target.value = null;
    };

    reader.readAsDataURL(files[0]);
  }, []);
  var createNewPages = useCallback(function (pageCount) {
    dispatch({
      type: ActionTypes.CreateNewPages,
      pageCount: pageCount
    });
  }, []);
  var setPageIndex = useCallback(function (index) {
    dispatch({
      type: ActionTypes.SetPageIndex,
      payload: {
        pageIndex: index
      }
    });
  }, []);

  var toggleTeachingMaterial = function toggleTeachingMaterial(teachingMaterialState) {
    dispatch({
      type: ActionTypes.ToggleTeachingMaterial,
      payload: {
        teachingMaterialState: !teachingMaterialState
      }
    });
  };

  var loadTeachingMaterials = useCallback(function (_ref2) {
    var materials = _ref2.materials;
    dispatch({
      type: ActionTypes.LoadTeachingMaterials,
      payload: {
        materials: materials
      }
    });
  }, []);

  var toggleChatRoom = function toggleChatRoom(chatRoomState) {
    dispatch({
      type: ActionTypes.ToggleChatRoom,
      payload: {
        chatRoomState: !chatRoomState
      }
    });
  };

  return {
    initial: initial,
    mouse: mouse,
    draw: draw,
    eraser: eraser,
    select: select,
    insertImage: insertImage,
    eraseAll: eraseAll,
    createNewPages: createNewPages,
    setPageIndex: setPageIndex,
    toggleTeachingMaterial: toggleTeachingMaterial,
    loadTeachingMaterials: loadTeachingMaterials,
    toggleChatRoom: toggleChatRoom
  };
};
CanvasProvider.propTypes = {
  children: PropTypes.node
};

function Canvas() {
  var containerRef = useRef();
  var canvasRef = useRef();

  var _useCanvasDispatch = useCanvasDispatch(),
      initial = _useCanvasDispatch.initial;

  useEffect(function () {
    if (!canvasRef.current) return;
    var canvas = new fabric.Canvas(canvasRef.current);
    canvas.on('mouse:down', function (opt) {
      var evt = opt.e;

      if (evt.altKey === true) {
        this.isDragging = true;
        this.selection = false;
        this.lastPosX = evt.clientX;
        this.lastPosY = evt.clientY;
      }
    });
    canvas.on('mouse:move', function (opt) {
      if (this.isDragging) {
        var e = opt.e;
        var vpt = this.viewportTransform;
        vpt[4] += e.clientX - this.lastPosX;
        vpt[5] += e.clientY - this.lastPosY;
        this.requestRenderAll();
        this.lastPosX = e.clientX;
        this.lastPosY = e.clientY;
      }
    });
    canvas.on('mouse:up', function (opt) {
      // on mouse up we want to recalculate new interaction
      // for all objects, so we call setViewportTransform
      this.setViewportTransform(this.viewportTransform);
      this.isDragging = false;
      this.selection = true;
    });
    canvas.on('mouse:wheel', function (opt) {
      var delta = opt.e.deltaY;
      var zoom = canvas.getZoom();
      zoom *= Math.pow(0.9, delta);
      if (zoom > 6) zoom = 6;
      if (zoom < 1) zoom = 1;

      if (zoom === 1) {
        this.setViewportTransform([1, 0, 0, 1, 0, 0]);
      } else {
        canvas.zoomToPoint({
          x: opt.e.offsetX,
          y: opt.e.offsetY
        }, zoom);
      }

      opt.e.preventDefault();
      opt.e.stopPropagation();
    });

    var setCurrentDimensions = function setCurrentDimensions() {
      canvas.setHeight(containerRef.current.clientHeight || 0);
      canvas.setWidth(containerRef.current.clientWidth || 0);
      canvas.renderAll();
    };

    var resizeCanvas = function resizeCanvas() {
      setCurrentDimensions();
    };

    setCurrentDimensions();
    window.addEventListener('resize', resizeCanvas, false);
    initial(canvas);
    return function () {
      canvas.dispose();
      window.removeEventListener('resize', resizeCanvas);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(Box, {
    ref: containerRef,
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React__default.createElement("canvas", {
    ref: canvasRef
  }));
}

var _g$2;

function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

function SvgAudioPlugin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    width: 29,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.43 11.5h-.149v-1.185C25.281 4.628 20.449 0 14.509 0S3.737 4.628 3.737 10.315V11.5h-.17C1.602 11.5 0 13.033 0 14.917v2.933c0 1.884 1.6 3.417 3.568 3.417h1.768c.843 0 1.527-.655 1.527-1.462v-6.843c0-.808-.684-1.461-1.527-1.461h-.072v-1.186c0-4.882 4.147-8.853 9.245-8.853 5.098 0 9.246 3.972 9.246 8.853V11.5h-.092c-.843 0-1.526.654-1.526 1.46v6.843c0 .808.683 1.462 1.526 1.462h1.768c1.968 0 3.569-1.533 3.569-3.417v-2.933c0-1.883-1.602-3.415-3.57-3.415zM5.338 12.963v6.842h-1.77c-1.122 0-2.04-.88-2.04-1.955v-2.933c0-1.075.918-1.955 2.04-1.955h1.77zm22.136 4.887c0 1.075-.919 1.955-2.042 1.955h-1.769v-6.842h1.769c1.123 0 2.042.88 2.042 1.955v2.932z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.596 24.167a.72.72 0 01-.72-.641l-.916-8.913-.933 5.232a.719.719 0 01-.636.59.724.724 0 01-.747-.444l-1.438-3.469-.45 1.957a.72.72 0 01-.705.555H8.457a.727.727 0 01-.511-.209.709.709 0 01.51-1.216h1.017l.829-3.61a.722.722 0 01.646-.55.726.726 0 01.73.438l1.357 3.276L14.44 9.29a.726.726 0 011.433.052L16.97 20.02l.608-1.835a.722.722 0 01.688-.492h1.275a.725.725 0 01.655.346.705.705 0 010 .733.725.725 0 01-.655.346h-.75l-1.507 4.555a.726.726 0 01-.689.494"
  }))));
}

var _defs, _path$1, _path2;

function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

function SvgDeleteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    className: "delete_icon_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    d: "M955.723 135.902H697.568V86.261A86.36 86.36 0 00611.308 0H407.023a86.36 86.36 0 00-86.26 86.26v49.642H68.276a27.25 27.25 0 00-27.237 27.25v4.537a27.237 27.237 0 0027.237 27.237h81.674v742.813a86.36 86.36 0 0086.26 86.261h551.577a86.36 86.36 0 0086.261-86.26V194.925h81.674a27.237 27.237 0 0027.237-27.237v-4.538a27.25 27.25 0 00-27.237-27.249zM379.787 86.261a27.262 27.262 0 0127.237-27.237h204.283a27.274 27.274 0 0127.237 27.237v49.641H379.787zm435.238 851.478a27.274 27.274 0 01-27.237 27.237H236.212a27.274 27.274 0 01-27.237-27.237V194.926h606.05z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M293.526 303.284h59.024V893.52h-59.024V303.284zM479.648 303.284h59.023V893.52h-59.023V303.284zM665.781 303.284h59.024V893.52h-59.024V303.284z",
    fill: "#fff"
  })));
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$2 = ".index-module_white-audio-plugin-container__pZWiH{box-shadow:0 0 4px 0 rgba(0,0,0,.2);display:flex;flex-flow:column nowrap;transform-origin:top left}.index-module_white-audio-plugin-nav__-MQMm{align-items:center;background-image:linear-gradient(180deg,#e0e1e0,#cdcdcc);box-shadow:0 0 4px 0 rgba(0,0,0,.2);display:flex;flex-shrink:0;height:32px}.index-module_white-audio-plugin-nav__-MQMm>svg{margin-left:8px;width:31px}.index-module_white-audio-plugin-nav-title__HBi1z{flex-grow:1;font-size:12px;font-weight:700;margin-left:6px}.index-module_white-audio-plugin-nav-delete__BAn8L{align-items:center;background-color:#ff756e;border:0;border-radius:50%;cursor:pointer;display:flex;height:22px;justify-content:center;margin-right:8px;opacity:.6;transition:opacity .2s ease;width:22px}.index-module_white-audio-plugin-nav-delete__BAn8L>svg{width:14px}.index-module_white-audio-plugin-nav-delete__BAn8L:hover{opacity:1}.index-module_white-audio-plugin-body__EUpzu{align-items:stretch;background-color:#f2f4f5;display:flex;flex-flow:column nowrap;flex-grow:1;justify-content:center}.index-module_white-audio-plugin-body__EUpzu>audio{flex-grow:1;outline:none;width:100%}.index-module_white-audio-trigger__2C-1N{align-items:center;background-color:hsla(0,0%,71%,.6);display:flex;gap:5px;height:100%;justify-content:center;pointer-events:auto;position:absolute;width:100%;z-index:10000}";
var styles$2 = {"white-audio-plugin-container":"index-module_white-audio-plugin-container__pZWiH","white-audio-plugin-nav":"index-module_white-audio-plugin-nav__-MQMm","white-audio-plugin-nav-title":"index-module_white-audio-plugin-nav-title__HBi1z","white-audio-plugin-nav-delete":"index-module_white-audio-plugin-nav-delete__BAn8L","white-audio-plugin-body":"index-module_white-audio-plugin-body__EUpzu","white-audio-trigger":"index-module_white-audio-trigger__2C-1N"};
styleInject(css_248z$2);

function play$1(_x) {
  return _play$1.apply(this, arguments);
}

function _play$1() {
  _play$1 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(player) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return player.play();

          case 3:
            return _context.abrupt("return", true);

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            _context.next = 10;
            return player.play();

          case 10:
            return _context.abrupt("return", false);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 6]]);
  }));
  return _play$1.apply(this, arguments);
}

var delay$1 = function delay(ms) {
  return new Promise(function (resolve) {
    return window.setTimeout(resolve, ms);
  });
};
var ChangedMap$2 = /*#__PURE__*/function () {
  function ChangedMap() {
    _classCallCheck(this, ChangedMap);

    _defineProperty(this, "map", new Map());
  }

  _createClass(ChangedMap, [{
    key: "changed",
    value: function changed(tag, value) {
      if (!this.map.has(tag) || !isEqual$2(this.map.get(tag), value)) {
        this.map.set(tag, value);
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.map.clear();
    }
  }]);

  return ChangedMap;
}();

function isEqual$2(a, b) {
  if (a === b) return true;
  if (Array.isArray(a)) return a.every(function (x, i) {
    return isEqual$2(x, b[i]);
  });
  return false;
} // https://stackoverflow.com/questions/44145740/how-does-double-requestanimationframe-work


function doubleRAF$1(callback) {
  window.requestAnimationFrame(function () {
    window.requestAnimationFrame(callback);
  });
}

var _g$1;

function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function SvgMuteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    width: 36,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.93.618L7.183 6.444H3.603C1.628 6.444.025 8.278.025 10.53v10.903c0 2.258 1.603 4.086 3.578 4.086h3.579l8.744 5.831a3.584 3.584 0 005.563-2.975V3.594c0-1.32-.728-2.53-1.89-3.149a3.55 3.55 0 00-3.668.173zM7.183 23.136H3.603c-.581 0-1.194-.697-1.194-1.703V10.536c0-1.006.608-1.703 1.194-1.703h3.579v14.303zm11.924 5.239c0 .44-.241.843-.629 1.047-.388.21-.86.184-1.22-.057l-7.692-5.119V7.722L17.251 2.6a1.189 1.189 0 011.85.995v24.78h.005z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 12l8.932 8.932M33.932 12L25 20.932"
  })))));
}

var _templateObject;
styled.p(_templateObject || (_templateObject = _taggedTemplateLiteral(["\nmargin: 0;\ncolor: #787878;\n\n"])));
/** 发送同步事件间隔秒 */

var SendInterval$1 = 2;
/** 同步上游播放时间误差秒 */

var SyncDiff$1 = 5;
var WhiteAudioPlugin = /*#__PURE__*/function (_Component) {
  _inherits(WhiteAudioPlugin, _Component);

  var _super = _createSuper(WhiteAudioPlugin);

  function WhiteAudioPlugin() {
    _classCallCheck(this, WhiteAudioPlugin);

    return _super.apply(this, arguments);
  }

  _createClass(WhiteAudioPlugin, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React__default.createElement(CNode, {
        context: this.props.cnode
      }, /*#__PURE__*/React__default.createElement(RoomConsumer, {
        children: function children(room) {
          return room && /*#__PURE__*/React__default.createElement(WhiteAudioPluginImpl, _extends$5({}, _this.props, {
            room: room
          }));
        }
      }), /*#__PURE__*/React__default.createElement(PlayerConsumer, {
        children: function children(player) {
          return player && /*#__PURE__*/React__default.createElement(WhiteAudioPluginImpl, _extends$5({}, _this.props, {
            player: player
          }));
        }
      }));
    }
  }]);

  return WhiteAudioPlugin;
}(Component);

var WhiteAudioPluginImpl = /*#__PURE__*/function (_Component2) {
  _inherits(WhiteAudioPluginImpl, _Component2);

  var _super2 = _createSuper(WhiteAudioPluginImpl);

  function WhiteAudioPluginImpl(props) {
    var _this2;

    _classCallCheck(this, WhiteAudioPluginImpl);

    _this2 = _super2.call(this, props);

    _defineProperty(_assertThisInitialized(_this2), "disposers", []);

    _defineProperty(_assertThisInitialized(_this2), "changedMap", new ChangedMap$2());

    _defineProperty(_assertThisInitialized(_this2), "player", /*#__PURE__*/createRef());

    _defineProperty(_assertThisInitialized(_this2), "timestamp", function () {
      var room = _this2.props.room;
      var player = _this2.player.current;
      var hostTime = (room === null || room === void 0 ? void 0 : room.calibrationTimestamp) || Date.now();
      return {
        currentTime: player.currentTime,
        hostTime: hostTime
      };
    });

    _defineProperty(_assertThisInitialized(_this2), "removeSelf", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var plugin;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              plugin = _this2.props.plugin;
              plugin.putAttributes(_objectSpread2({
                paused: true
              }, _this2.timestamp()));
              _context.next = 4;
              return delay$1(300);

            case 4:
              plugin.remove();

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this2), "triggerHandle", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
        var eventType, player;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                eventType = event.type;
                player = _this2.player.current;

                _this2.setState(_objectSpread2(_objectSpread2({}, _this2.state), {}, {
                  triggerState: true
                }));

                _context2.next = 5;
                return play$1(player);

              case 5:
                if (eventType === 'touchend') {
                  event.preventDefault();
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _this2.state = {
      triggerState: false
    };
    return _this2;
  }

  _createClass(WhiteAudioPluginImpl, [{
    key: "isHost",
    value: function isHost() {
      return this.props.room && this.props.plugin.context.identity === "host";
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.room) {
        if (this.isHost()) {
          this.setupHost();
        } else {
          this.setupNonHost();
        }
      }

      if (this.props.player) {
        this.setupNonHost();
      }
    }
  }, {
    key: "setupHost",
    value: function setupHost() {
      var _this3 = this;

      var plugin = this.props.plugin;
      var player = this.player.current;
      player.currentTime = plugin.attributes.currentTime;
      autorun( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var src;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                src = plugin.attributes.src;

                if (!_this3.changedMap.changed("src", src)) {
                  _context3.next = 5;
                  break;
                }

                player.src = plugin.attributes.src;
                _context3.next = 5;
                return play$1(player);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
      player.addEventListener("play", function () {
        plugin.putAttributes(_objectSpread2({
          paused: false
        }, _this3.timestamp()));
      });
      player.addEventListener("pause", function () {
        plugin.putAttributes(_objectSpread2({
          paused: true
        }, _this3.timestamp()));
      });
      player.addEventListener("seeked", function () {
        plugin.putAttributes(_this3.timestamp());
      });
      player.addEventListener("volumechange", function () {
        plugin.putAttributes({
          volume: player.volume,
          muted: player.muted
        });
      });
      var timer = NaN;
      player.addEventListener("timeupdate", function () {
        timer || (timer = window.setTimeout(function () {
          timer = NaN;
          plugin.putAttributes(_this3.timestamp());
        }, SendInterval$1 * 1000));
      });
      this.disposers.push(function () {
        return window.clearTimeout(timer);
      });
      player.addEventListener("ended", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                plugin.putAttributes(_objectSpread2({
                  paused: true
                }, _this3.timestamp()));
                _context4.next = 3;
                return delay$1(500);

              case 3:
                player.load();

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      })));

      if (/iPad|iPhone|iPod/.test(navigator.platform)) {
        doubleRAF$1(function () {
          player.currentTime = plugin.attributes.currentTime;
        });
      }
    }
  }, {
    key: "setupNonHost",
    value: function setupNonHost() {
      var _this4 = this;

      var _this$props = this.props,
          plugin = _this$props.plugin,
          room = _this$props.room;
      var player = this.player.current; // n.b. reaction() 对 plugin.attributes 不起效，sdk 总是更新整个 attributes
      //      因此这里使用 autorun 和自己写的 changed() 检查变化

      var disposer = autorun( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var isPlaying, playerTimestamp, playbackSpeed, _plugin$attributes, paused, volume, muted, currentTime, hostTime, src, now, hostCurrentTime;

        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                isPlaying = plugin.isPlaying, playerTimestamp = plugin.playerTimestamp, playbackSpeed = plugin.playbackSpeed;
                _plugin$attributes = plugin.attributes, paused = _plugin$attributes.paused, volume = _plugin$attributes.volume, muted = _plugin$attributes.muted, currentTime = _plugin$attributes.currentTime, hostTime = _plugin$attributes.hostTime, src = _plugin$attributes.src;

                if (!_this4.changedMap.changed("paused", [paused, isPlaying])) {
                  _context5.next = 9;
                  break;
                }

                if (!(paused || !isPlaying)) {
                  _context5.next = 7;
                  break;
                }

                player.pause();
                _context5.next = 9;
                break;

              case 7:
                _context5.next = 9;
                return play$1(player);

              case 9:
                if (_this4.changedMap.changed("volume", [volume, muted])) {
                  player.volume = plugin.attributes.volume;
                  player.muted = plugin.attributes.muted;
                }

                if (_this4.changedMap.changed("time", [currentTime, hostTime]) && hostTime > 0) {
                  now = (room === null || room === void 0 ? void 0 : room.calibrationTimestamp) || Date.now();

                  if (_this4.props.player) {
                    now = _this4.props.player.beginTimestamp + playerTimestamp;
                  }

                  hostCurrentTime = currentTime + (now - hostTime) / 1000;

                  if (hostCurrentTime > 0 && Math.abs(player.currentTime - hostCurrentTime) > SyncDiff$1) {
                    player.currentTime = hostCurrentTime;
                  }
                }

                if (_this4.changedMap.changed("rate", playbackSpeed)) {
                  player.playbackRate = playbackSpeed;
                }

                if (!_this4.changedMap.changed("src", src)) {
                  _context5.next = 16;
                  break;
                }

                player.src = src;
                _context5.next = 16;
                return play$1(player);

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      })));
      this.disposers.push(disposer);
      this.disposers.push(function () {
        return _this4.changedMap.clear();
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$player$current;

      (_this$player$current = this.player.current) === null || _this$player$current === void 0 ? void 0 : _this$player$current.pause();
      this.disposers.forEach(function (dispose) {
        return dispose();
      });
    }
  }, {
    key: "containerStyle",
    get: function get() {
      var _this$props2 = this.props,
          size = _this$props2.size,
          _scale = _this$props2.scale;
      var scale = _scale || 1;
      return {
        width: size.width / scale,
        height: size.height / scale,
        transform: "scale(".concat(scale, ")")
      };
    }
  }, {
    key: "pointerEventsStyle",
    get: function get() {
      return {
        pointerEvents: this.isHost() ? "auto" : "none"
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props3 = this.props,
          room = _this$props3.room,
          player = _this$props3.player,
          plugin = _this$props3.plugin;
      if (!room && !player) return null;
      return /*#__PURE__*/React__default.createElement("div", {
        className: styles$2["white-audio-plugin-container"],
        style: this.containerStyle
      }, !plugin.attributes.isNavigationDisable && /*#__PURE__*/React__default.createElement("div", {
        className: styles$2["white-audio-plugin-nav"]
      }, /*#__PURE__*/React__default.createElement(SvgAudioPlugin, null), /*#__PURE__*/React__default.createElement("span", {
        className: styles$2["white-audio-plugin-nav-title"]
      }, "Audio Player"), /*#__PURE__*/React__default.createElement("span", {
        className: styles$2["white-audio-plugin-nav-delete"],
        style: this.pointerEventsStyle,
        onClick: this.removeSelf
      }, /*#__PURE__*/React__default.createElement(SvgDeleteIcon, null))), /*#__PURE__*/React__default.createElement("div", {
        className: styles$2["white-audio-plugin-body"]
      }, /*#__PURE__*/React__default.createElement("audio", {
        src: plugin.attributes.src,
        style: this.pointerEventsStyle,
        controls: !!room,
        controlsList: "nodownload nofullscreen",
        preload: "auto",
        ref: this.player
      })), !this.isHost() && (isIOS || isMacOs && isSafari) && !this.state.triggerState && /*#__PURE__*/React__default.createElement("div", {
        className: styles$2["white-audio-trigger"],
        onTouchEnd: function onTouchEnd(e) {
          return _this5.triggerHandle(e);
        },
        onClick: function onClick(e) {
          return _this5.triggerHandle(e);
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          fontSize: '22px'
        }
      }, "\u82E5\u8981\u64AD\u653E\u97F3\u6A94\uFF0C\u8ACB\u9EDE\u64CA\u89E3\u9396\u64AD\u653E\u6309\u9215"), /*#__PURE__*/React__default.createElement(SvgMuteIcon, null)));
    }
  }]);

  return WhiteAudioPluginImpl;
}(Component);

/**
 * white-web-sdk audio plugin.
 * @example
 * const plugins = createPlugins({ "audio2": audioPlugin2 });
 * plugins.setPluginContext("audio2", {
 *     identity: identity === Identity.creator ? "host" : ""
 * });
 * let sdk = new WhiteWebSdk({ plugins });
 * let room = await sdk.joinRoom(...);
 * room.insertPlugin("audio2", {
 *     ...,
 *     attributes: { src: url, isNavigationDisable: false },
 * });
 */

var audioPlugin2 = {
  kind: "audio2",
  render: WhiteAudioPlugin,
  defaultAttributes: {
    src: "",
    hostTime: 0,
    currentTime: 0,
    paused: true,
    muted: false,
    volume: 1
  },
  hitTest: function hitTest(plugin) {
    var memberState = plugin.component.context.getMemberState();
    return !((memberState === null || memberState === void 0 ? void 0 : memberState.currentApplianceName) === "eraser");
  }
};

var _g;

function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function SvgVideoPlugin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    width: 31,
    height: 27,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2C2C2C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.675 26.084H3.753C1.686 26.084 0 24.326 0 22.154V3.932C0 1.766 1.68 0 3.753 0h22.922c2.067 0 3.755 1.76 3.755 3.931v18.224c-.009 2.162-1.688 3.929-3.755 3.929zM3.753 1.424c-1.32 0-2.398 1.13-2.398 2.514V22.16c0 1.384 1.077 2.51 2.398 2.51h22.922c1.32 0 2.4-1.126 2.4-2.51V3.931c0-1.384-1.08-2.513-2.4-2.513H3.753v.007z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.027 26.077a.696.696 0 01-.676-.71V.71c0-.391.304-.709.676-.709.383.01.686.326.68.71v24.658c0 .391-.299.709-.68.709zm19.988 0a.696.696 0 01-.676-.71V.71c0-.391.304-.709.676-.709.383.01.686.326.68.71v24.658a.696.696 0 01-.68.709z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.62 7.945H.6c-.33 0-.6-.32-.6-.71 0-.391.27-.709.6-.709h4.02c.331 0 .601.32.601.71 0 .391-.263.709-.6.709zm0 5.562H.6c-.33 0-.6-.32-.6-.709 0-.391.27-.71.6-.71h4.02c.331 0 .601.319.601.71 0 .39-.263.71-.6.71zm0 6.263H.6c-.33 0-.6-.32-.6-.709 0-.391.27-.709.6-.709h4.02c.331 0 .601.32.601.71 0 .39-.263.708-.6.708zM29.37 7.945h-4.352c-.36 0-.65-.32-.65-.71 0-.391.29-.709.65-.709h4.35c.357 0 .65.32.65.71 0 .391-.293.709-.65.709h.003zm0 5.562h-4.352c-.36 0-.65-.32-.65-.709 0-.391.29-.71.65-.71h4.35c.357 0 .65.319.65.71 0 .39-.293.71-.65.71h.003zm0 6.263h-4.352c-.36 0-.65-.32-.65-.709 0-.391.29-.709.65-.709h4.35c.357 0 .65.32.65.71 0 .39-.293.708-.65.708h.003zm-17.816-.907a.642.642 0 01-.337-.091.718.718 0 01-.34-.618V9.415a.718.718 0 01.34-.618.646.646 0 01.676 0l7.23 4.37a.718.718 0 01.339.617.718.718 0 01-.34.617l-7.229 4.364a.67.67 0 01-.34.098zm.678-8.223v6.287l5.198-3.143-5.2-3.142.002-.002z"
  }))));
}

var css_248z$1 = ".index-module_white-video-plugin-container__e9mxv{box-shadow:0 0 4px 0 rgba(0,0,0,.2);display:flex;flex-flow:column nowrap;position:relative;transform-origin:top left}.index-module_white-video-plugin-ios-poster__NiWoz{bottom:0;left:0;position:absolute;right:0;top:0;z-index:1}.index-module_white-video-plugin-ios-poster__NiWoz>img{height:100%;width:100%}.index-module_white-video-plugin-nav__gPecz{align-items:center;background-image:linear-gradient(180deg,#e0e1e0,#cdcdcc);box-shadow:0 0 4px 0 rgba(0,0,0,.2);display:flex;flex-shrink:0;height:32px;z-index:2}.index-module_white-video-plugin-nav__gPecz>svg{margin-left:8px;width:31px}.index-module_white-video-plugin-nav-title__OLUkY{flex-grow:1;font-size:12px;font-weight:700;margin-left:6px}.index-module_white-video-plugin-nav-delete__lgh1t{align-items:center;background-color:#ff756e;border:0;border-radius:50%;cursor:pointer;display:flex;height:22px;justify-content:center;margin-right:8px;opacity:.6;transition:opacity .2s ease;width:22px}.index-module_white-video-plugin-nav-delete__lgh1t>svg{width:14px}.index-module_white-video-plugin-nav-delete__lgh1t:hover{opacity:1}.index-module_white-video-plugin-body__8X47f{align-items:stretch;background-color:#f2f4f5;display:flex;flex-flow:column nowrap;flex-grow:1;height:68%;justify-content:center;z-index:2}.index-module_white-video-plugin-body__8X47f>audio{flex-grow:1;outline:none}.index-module_white-video-trigger__3pf0P{align-items:center;background-color:hsla(0,0%,71%,.6);display:flex;height:100%;justify-content:center;pointer-events:auto;position:absolute;width:100%;z-index:10000}";
var styles$1 = {"white-video-plugin-container":"index-module_white-video-plugin-container__e9mxv","white-video-plugin-ios-poster":"index-module_white-video-plugin-ios-poster__NiWoz","white-video-plugin-nav":"index-module_white-video-plugin-nav__gPecz","white-video-plugin-nav-title":"index-module_white-video-plugin-nav-title__OLUkY","white-video-plugin-nav-delete":"index-module_white-video-plugin-nav-delete__lgh1t","white-video-plugin-body":"index-module_white-video-plugin-body__8X47f","white-video-trigger":"index-module_white-video-trigger__3pf0P"};
styleInject(css_248z$1);

function play(_x) {
  return _play.apply(this, arguments);
}

function _play() {
  _play = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(player) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return player.play();

          case 3:
            return _context.abrupt("return", true);

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            _context.next = 10;
            return player.play();

          case 10:
            return _context.abrupt("return", false);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 6]]);
  }));
  return _play.apply(this, arguments);
}

var delay = function delay(ms) {
  return new Promise(function (resolve) {
    return window.setTimeout(resolve, ms);
  });
};
var ChangedMap$1 = /*#__PURE__*/function () {
  function ChangedMap() {
    _classCallCheck(this, ChangedMap);

    _defineProperty(this, "map", new Map());
  }

  _createClass(ChangedMap, [{
    key: "changed",
    value: function changed(tag, value) {
      if (!this.map.has(tag) || !isEqual$1(this.map.get(tag), value)) {
        this.map.set(tag, value);
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.map.clear();
    }
  }]);

  return ChangedMap;
}();

function isEqual$1(a, b) {
  if (a === b) return true;
  if (Array.isArray(a)) return a.every(function (x, i) {
    return isEqual$1(x, b[i]);
  });
  return false;
} // https://stackoverflow.com/questions/44145740/how-does-double-requestanimationframe-work


function doubleRAF(callback) {
  window.requestAnimationFrame(function () {
    window.requestAnimationFrame(callback);
  });
}

/** 发送同步事件间隔秒 */

var SendInterval = 2;
/** 同步上游播放时间误差秒 */

var SyncDiff = 2;
var WhiteVideoPlugin = /*#__PURE__*/function (_Component) {
  _inherits(WhiteVideoPlugin, _Component);

  var _super = _createSuper(WhiteVideoPlugin);

  function WhiteVideoPlugin() {
    _classCallCheck(this, WhiteVideoPlugin);

    return _super.apply(this, arguments);
  }

  _createClass(WhiteVideoPlugin, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React__default.createElement(CNode, {
        context: this.props.cnode
      }, /*#__PURE__*/React__default.createElement(RoomConsumer, {
        children: function children(room) {
          return room && /*#__PURE__*/React__default.createElement(WhiteVideoPluginImpl, _extends$5({}, _this.props, {
            room: room
          }));
        }
      }), /*#__PURE__*/React__default.createElement(PlayerConsumer, {
        children: function children(player) {
          return player && /*#__PURE__*/React__default.createElement(WhiteVideoPluginImpl, _extends$5({}, _this.props, {
            player: player
          }));
        }
      }));
    }
  }]);

  return WhiteVideoPlugin;
}(Component);

var WhiteVideoPluginImpl = /*#__PURE__*/function (_Component2) {
  _inherits(WhiteVideoPluginImpl, _Component2);

  var _super2 = _createSuper(WhiteVideoPluginImpl);

  function WhiteVideoPluginImpl(props) {
    var _this2;

    _classCallCheck(this, WhiteVideoPluginImpl);

    _this2 = _super2.call(this, props);

    _defineProperty(_assertThisInitialized(_this2), "disposers", []);

    _defineProperty(_assertThisInitialized(_this2), "changedMap", new ChangedMap$1());

    _defineProperty(_assertThisInitialized(_this2), "player", /*#__PURE__*/createRef());

    _defineProperty(_assertThisInitialized(_this2), "timestamp", function () {
      var room = _this2.props.room;
      var player = _this2.player.current;
      return {
        currentTime: player.currentTime,
        hostTime: (room === null || room === void 0 ? void 0 : room.calibrationTimestamp) || Date.now()
      };
    });

    _defineProperty(_assertThisInitialized(_this2), "removeSelf", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var plugin;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              plugin = _this2.props.plugin;
              plugin.putAttributes(_objectSpread2({
                paused: true
              }, _this2.timestamp()));
              _context.next = 4;
              return delay(300);

            case 4:
              plugin.remove();

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this2), "triggerHandle", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
        var eventType, player;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                eventType = event.type;
                player = _this2.player.current;

                _this2.setState(_objectSpread2(_objectSpread2({}, _this2.state), {}, {
                  triggerState: true
                }));

                _context2.next = 5;
                return play(player);

              case 5:
                if (eventType === 'touchend') {
                  event.preventDefault();
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _this2.state = {
      triggerState: false
    };
    return _this2;
  }

  _createClass(WhiteVideoPluginImpl, [{
    key: "isHost",
    value: function isHost() {
      return this.props.room && this.props.plugin.context.identity === "host";
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.room) {
        if (this.isHost()) {
          this.setupHost();
        } else {
          this.setupNonHost();
        }
      }

      if (this.props.player) {
        this.setupNonHost();
      }
    }
  }, {
    key: "setupHost",
    value: function setupHost() {
      var _this3 = this;

      var plugin = this.props.plugin;
      var player = this.player.current;
      player.currentTime = plugin.attributes.currentTime;
      autorun( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var src;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                src = plugin.attributes.src;

                if (!_this3.changedMap.changed("src", src)) {
                  _context3.next = 5;
                  break;
                }

                player.src = plugin.attributes.src;
                _context3.next = 5;
                return play(player);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
      player.addEventListener("play", function () {
        plugin.putAttributes(_objectSpread2({
          paused: false
        }, _this3.timestamp()));
      });
      player.addEventListener("pause", function () {
        plugin.putAttributes(_objectSpread2({
          paused: true
        }, _this3.timestamp()));
      });
      player.addEventListener("seeked", function () {
        plugin.putAttributes(_this3.timestamp());
      });
      player.addEventListener("volumechange", function () {
        plugin.putAttributes({
          volume: player.volume,
          muted: player.muted
        });
      });
      var timer = NaN;
      player.addEventListener("timeupdate", function () {
        timer || (timer = window.setTimeout(function () {
          timer = NaN;
          plugin.putAttributes(_this3.timestamp());
        }, SendInterval * 1000));
      });
      this.disposers.push(function () {
        return window.clearTimeout(timer);
      });
      player.addEventListener("ended", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                plugin.putAttributes(_objectSpread2({
                  paused: true
                }, _this3.timestamp()));
                _context4.next = 3;
                return delay(500);

              case 3:
                player.load();

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      })));

      if (/iPad|iPhone|iPod/.test(navigator.platform)) {
        doubleRAF(function () {
          player.currentTime = plugin.attributes.currentTime;
        });
      }
    }
  }, {
    key: "setupNonHost",
    value: function setupNonHost() {
      var _this4 = this;

      var _this$props = this.props,
          plugin = _this$props.plugin,
          room = _this$props.room;
      var player = this.player.current; // n.b. reaction() 对 plugin.attributes 不起效，sdk 总是更新整个 attributes
      //      因此这里使用 autorun 和自己写的 changed() 检查变化

      var disposer = autorun( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var isPlaying, playerTimestamp, playbackSpeed, _plugin$attributes, paused, volume, muted, currentTime, hostTime, src, now, hostCurrentTime;

        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                isPlaying = plugin.isPlaying, playerTimestamp = plugin.playerTimestamp, playbackSpeed = plugin.playbackSpeed;
                _plugin$attributes = plugin.attributes, paused = _plugin$attributes.paused, volume = _plugin$attributes.volume, muted = _plugin$attributes.muted, currentTime = _plugin$attributes.currentTime, hostTime = _plugin$attributes.hostTime, src = _plugin$attributes.src;

                if (!_this4.changedMap.changed("paused", [paused, isPlaying])) {
                  _context5.next = 9;
                  break;
                }

                if (!(paused || !isPlaying)) {
                  _context5.next = 7;
                  break;
                }

                player.pause();
                _context5.next = 9;
                break;

              case 7:
                _context5.next = 9;
                return play(player);

              case 9:
                if (_this4.changedMap.changed("volume", [volume, muted])) {
                  player.volume = plugin.attributes.volume;
                  player.muted = plugin.attributes.muted;
                }

                if (_this4.changedMap.changed("time", [currentTime, hostTime]) && hostTime > 0) {
                  now = (room === null || room === void 0 ? void 0 : room.calibrationTimestamp) || Date.now();

                  if (_this4.props.player) {
                    now = _this4.props.player.beginTimestamp + playerTimestamp;
                  }

                  hostCurrentTime = currentTime + (now - hostTime) / 1000;

                  if (Math.abs(player.currentTime - hostCurrentTime) > SyncDiff) {
                    player.currentTime = hostCurrentTime;
                  }
                }

                if (_this4.changedMap.changed("rate", playbackSpeed)) {
                  player.playbackRate = playbackSpeed;
                }

                if (!_this4.changedMap.changed("src", src)) {
                  _context5.next = 16;
                  break;
                }

                player.src = plugin.attributes.src;
                _context5.next = 16;
                return play(player);

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      })));
      this.disposers.push(disposer);
      this.disposers.push(function () {
        return _this4.changedMap.clear();
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$player$current;

      (_this$player$current = this.player.current) === null || _this$player$current === void 0 ? void 0 : _this$player$current.pause();
      this.disposers.forEach(function (dispose) {
        return dispose();
      });
    }
  }, {
    key: "containerStyle",
    get: function get() {
      var _this$props2 = this.props,
          size = _this$props2.size,
          _scale = _this$props2.scale;
      var scale = _scale || 1;
      return {
        width: size.width / scale,
        height: size.height / scale,
        transform: "scale(".concat(scale, ")")
      };
    }
  }, {
    key: "pointerEventsStyle",
    get: function get() {
      return {
        pointerEvents: this.isHost() ? "auto" : "none"
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props3 = this.props,
          room = _this$props3.room,
          player = _this$props3.player,
          plugin = _this$props3.plugin;
      if (!room && !player) return null;
      return /*#__PURE__*/React__default.createElement("div", {
        className: styles$1['white-video-plugin-container'],
        style: this.containerStyle
      }, plugin.attributes.poster && /*#__PURE__*/React__default.createElement("div", {
        className: styles$1["white-video-plugin-ios-poster"]
      }, /*#__PURE__*/React__default.createElement("img", {
        src: plugin.attributes.poster,
        alt: ""
      })), !plugin.attributes.isNavigationDisable && /*#__PURE__*/React__default.createElement("div", {
        className: styles$1["white-video-plugin-nav"]
      }, /*#__PURE__*/React__default.createElement(SvgVideoPlugin, null), /*#__PURE__*/React__default.createElement("span", {
        className: styles$1["white-video-plugin-nav-title"]
      }, "Video Player"), /*#__PURE__*/React__default.createElement("span", {
        className: styles$1["white-video-plugin-nav-delete"],
        style: this.pointerEventsStyle,
        onClick: this.removeSelf
      }, /*#__PURE__*/React__default.createElement(SvgDeleteIcon, null))), /*#__PURE__*/React__default.createElement("div", {
        className: styles$1["white-video-plugin-body"]
      }, /*#__PURE__*/React__default.createElement("video", {
        src: plugin.attributes.src,
        style: _objectSpread2({
          maxWidth: "100%",
          maxHeight: "100%"
        }, this.pointerEventsStyle),
        controls: !!room,
        controlsList: "nodownload nofullscreen",
        preload: "metadata",
        ref: this.player,
        playsInline: true,
        "webkit-playsinline": "true",
        poster: plugin.attributes.poster,
        disablePictureInPicture: true
      })), !this.isHost() && (isIOS || isMacOs && isSafari) && !this.state.triggerState && /*#__PURE__*/React__default.createElement("div", {
        className: styles$1["white-video-trigger"],
        onTouchEnd: function onTouchEnd(e) {
          return _this5.triggerHandle(e);
        },
        onClick: function onClick(e) {
          return _this5.triggerHandle(e);
        }
      }, /*#__PURE__*/React__default.createElement(SvgMuteIcon, null)));
    }
  }]);

  return WhiteVideoPluginImpl;
}(Component);

/**
 * white-web-sdk video plugin.
 * @example
 * const plugins = createPlugins({ "video": videoPlugin });
 * plugins.setPluginContext("video", {
 *     identity: identity === Identity.creator ? "host" : ""
 * });
 * let sdk = new WhiteWebSdk({ plugins });
 * let room = await sdk.joinRoom(...);
 * room.insertPlugin("video", {
 *     ...,
 *     attributes: { src: url, poster: url2, isNavigationDisable: false },
 * });
 */

var videoPlugin2 = {
  kind: "video2",
  render: WhiteVideoPlugin,
  defaultAttributes: {
    src: "",
    hostTime: 0,
    currentTime: 0,
    paused: true,
    muted: false,
    volume: 1
  },
  hitTest: function hitTest(plugin) {
    var memberState = plugin.component.context.getMemberState();
    return !((memberState === null || memberState === void 0 ? void 0 : memberState.currentApplianceName) === "eraser");
  }
};

var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgXmarkOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.353 19.91c-.464.464-.477 1.273 0 1.737.477.464 1.273.464 1.737 0l7.917-7.916 7.903 7.916c.477.464 1.273.477 1.737 0 .464-.477.464-1.273 0-1.737l-7.916-7.917 7.916-7.903c.464-.477.477-1.273 0-1.737a1.258 1.258 0 00-1.737 0l-7.903 7.917L4.09 2.353c-.464-.464-1.273-.477-1.737 0-.464.477-.464 1.273 0 1.724l7.917 7.916-7.917 7.917z",
    fill: "#000"
  })));
}

var ChangedMap = /*#__PURE__*/function () {
  function ChangedMap() {
    _classCallCheck(this, ChangedMap);

    _defineProperty(this, "map", new Map());
  }

  _createClass(ChangedMap, [{
    key: "changed",
    value: function changed(tag, value) {
      if (!this.map.has(tag) || !isEqual(this.map.get(tag), value)) {
        this.map.set(tag, value);
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.map.clear();
    }
  }]);

  return ChangedMap;
}();

function isEqual(a, b) {
  if (a === b) return true;
  if (Array.isArray(a)) return a.every(function (x, i) {
    return isEqual(x, b[i]);
  });
  return false;
} // https://stackoverflow.com/questions/44145740/how-does-double-requestanimationframe-work

var css_248z = ".index-module_cnode__Fdbyy{align-items:center;display:flex;justify-items:center}.index-module_container__y2-G5{position:relative}.index-module_host__vYrXZ{pointer-events:auto}.index-module_controls__eKDp8{align-items:center;background-color:#f44336;border-radius:50%;box-shadow:0 23px 44px rgba(3,8,17,.14);color:#fff;cursor:pointer;display:flex;height:24px;justify-content:center;padding:4px;position:absolute;right:0;top:0;transform:translate(50%,-50%);width:24px;z-index:2}.index-module_controls__eKDp8 svg{color:#fff}.index-module_controls__eKDp8 svg path{fill:#fff}.index-module_video__LxL5c{display:inline-block;height:100%;width:100%}";
var styles = {"cnode":"index-module_cnode__Fdbyy","container":"index-module_container__y2-G5","host":"index-module_host__vYrXZ","controls":"index-module_controls__eKDp8","video":"index-module_video__LxL5c"};
styleInject(css_248z);

var ControllableVideoPlugin = /*#__PURE__*/function (_Component) {
  _inherits(ControllableVideoPlugin, _Component);

  var _super = _createSuper(ControllableVideoPlugin);

  function ControllableVideoPlugin() {
    _classCallCheck(this, ControllableVideoPlugin);

    return _super.apply(this, arguments);
  }

  _createClass(ControllableVideoPlugin, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React__default.createElement(CNode, {
        className: styles.cnode,
        context: this.props.cnode
      }, /*#__PURE__*/React__default.createElement(RoomConsumer, {
        children: function children(room) {
          return room && /*#__PURE__*/React__default.createElement(ControllableVideoPluginImpl, _extends$5({}, _this.props, {
            plugin: _this.props.plugin,
            room: room
          }));
        }
      }));
    }
  }]);

  return ControllableVideoPlugin;
}(Component);
var ControllableVideoPluginImpl = /*#__PURE__*/function (_Component2) {
  _inherits(ControllableVideoPluginImpl, _Component2);

  var _super2 = _createSuper(ControllableVideoPluginImpl);

  // meetingSession = null;
  function ControllableVideoPluginImpl(props) {
    var _this2;

    _classCallCheck(this, ControllableVideoPluginImpl);

    _this2 = _super2.call(this, props);

    _defineProperty(_assertThisInitialized(_this2), "disposers", []);

    _defineProperty(_assertThisInitialized(_this2), "changedMap", new ChangedMap());

    _defineProperty(_assertThisInitialized(_this2), "audioVideo", null);

    _defineProperty(_assertThisInitialized(_this2), "attendeeId", '');

    _defineProperty(_assertThisInitialized(_this2), "attendeeIdToTileId", {});

    _defineProperty(_assertThisInitialized(_this2), "tileId", null);

    _defineProperty(_assertThisInitialized(_this2), "selfAttendeeId", '');

    _defineProperty(_assertThisInitialized(_this2), "removeSelf", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this2$props, plugin, room, attendeeId, payload;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2$props = _this2.props, plugin = _this2$props.plugin, room = _this2$props.room;
              attendeeId = plugin.attributes.attendeeId;

              if (_this2.tileId) {
                _this2.audioVideo.unbindVideoElement(_this2.tileId);

                payload = {
                  attendeeId: attendeeId
                };
                room.dispatchMagixEvent('deleteObjectedVideo', payload);
              }

              plugin.remove();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _this2.videoRef = /*#__PURE__*/createRef();
    _this2.audioVideo = _this2.props.plugin.context.meetingManager.audioVideo;
    _this2.selfAttendeeId = _this2.props.plugin.context.selfAttendeeId;
    return _this2;
  }

  _createClass(ControllableVideoPluginImpl, [{
    key: "localTileId",
    value: function localTileId() {
      return this.audioVideo.hasStartedLocalVideoTile() ? this.audioVideo.getLocalVideoTile().state().tileId : null;
    }
  }, {
    key: "isHost",
    value: function isHost() {
      return this.props.room && this.props.plugin.context.identity === "host";
    }
  }, {
    key: "setup",
    value: function setup() {
      var _this3 = this;

      var plugin = this.props.plugin;
      var disposer = autorun( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var attendeeId, attendeeIdToTileId, tileId;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                attendeeId = plugin.attributes.attendeeId;
                attendeeIdToTileId = plugin.context.attendeeIdToTileId;

                if (_this3.videoRef.current) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                if (!_this3.changedMap.changed("attendeeId", [attendeeId])) {
                  _context2.next = 9;
                  break;
                }

                if (attendeeId) {
                  _context2.next = 8;
                  break;
                }

                plugin.remove();
                return _context2.abrupt("return");

              case 8:
                _this3.attendeeId = attendeeId;

              case 9:
                if (_this3.changedMap.changed("attendeeIdToTileId", [attendeeIdToTileId])) {
                  _this3.attendeeIdToTileId = attendeeIdToTileId;
                }

                if (_this3.selfAttendeeId === _this3.attendeeId) {
                  tileId = _this3.localTileId();
                } else {
                  tileId = _this3.attendeeIdToTileId[_this3.attendeeId];
                }

                _this3.tileId = tileId;

                if (tileId) {
                  _context2.next = 15;
                  break;
                }

                _this3.removeSelf();

                return _context2.abrupt("return");

              case 15:
                _this3.audioVideo.bindVideoElement(tileId, _this3.videoRef.current);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
      this.disposers.push(disposer);
      this.disposers.push(function () {
        return _this3.changedMap.clear();
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setup();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeSelf();
    }
  }, {
    key: "containerStyle",
    get: function get() {
      var _this$props = this.props,
          size = _this$props.size,
          _scale = _this$props.scale;
      var scale = _scale || 1;
      return {
        width: size.width / scale,
        height: size.height / scale,
        transform: "scale(".concat(scale, ")")
      };
    }
  }, {
    key: "pointerEventsStyle",
    get: function get() {
      return {
        pointerEvents: this.isHost() ? "auto" : "none"
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$plugin, _this$props$plugin$co;

      return /*#__PURE__*/React__default.createElement("div", {
        className: styles.container,
        style: styles.containerStyle
      }, ((_this$props$plugin = this.props.plugin) === null || _this$props$plugin === void 0 ? void 0 : (_this$props$plugin$co = _this$props$plugin.context) === null || _this$props$plugin$co === void 0 ? void 0 : _this$props$plugin$co.identity) === "host" && /*#__PURE__*/React__default.createElement("div", {
        className: styles.controls,
        style: this.pointerEventsStyle,
        onClick: this.removeSelf
      }, /*#__PURE__*/React__default.createElement(SvgXmarkOutline, null)), /*#__PURE__*/React__default.createElement("video", {
        className: styles.video,
        ref: this.videoRef
      }));
    }
  }]);

  return ControllableVideoPluginImpl;
}(Component);

/**
 * white-web-sdk video plugin.
 * @example
 * const plugins = createPlugins({ "video": videoPlugin });
 * plugins.setPluginContext("video", {
 *     identity: identity === Identity.creator ? "host" : ""
 * });
 * let sdk = new WhiteWebSdk({ plugins });
 * let room = await sdk.joinRoom(...);
 * room.insertPlugin("video", {
 *     ...,
 *     attributes: { src: url, poster: url2, isNavigationDisable: false },
 * });
 */

var controllableVideoPlugin = {
  kind: 'controllableVideo',
  render: ControllableVideoPlugin,
  defaultAttributes: {
    attendeeIdToTileId: {},
    attendeeId: '',
    selfAttendeeId: ''
  },
  hitTest: function hitTest(plugin) {
    var memberState = plugin.component.context.getMemberState();
    return !((memberState === null || memberState === void 0 ? void 0 : memberState.currentApplianceName) === "eraser");
  }
};

var BASE_URL = process.env.REACT_APP_ONEBOARD_API_URL;
var Context = /*#__PURE__*/createContext();

var createPathName = function createPathName(path) {
  var cells = path.split('/');
  var popCell = cells.pop();

  if (popCell === '') {
    cells.pop();
  }

  return cells.join('/');
};

var useWhiteboardService = function useWhiteboardService() {
  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      service = _useState2[0],
      setService = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      whiteboardPhase = _useState6[0],
      setWhiteboardPhase = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      whiteboardError = _useState8[0],
      setWhiteboardError = _useState8[1];

  var regex = /(chromium)/i;
  osName.match(regex);
  var userAgent = navigator.userAgent;
  /linux x86/i.test(userAgent) && /SamsungBrowser/i.test(userAgent);
  var cursorAdapter = new CursorTool();
  var joinWhiteboard = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
      var meetingId, role, userName, userId, userPayload, res, plugins, deviceType, _res$data, appIdentifier, boardId, boardToken, boardRegion, whiteWebSdk, hotKeys, options;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              meetingId = _ref.meetingId, role = _ref.role, userName = _ref.userName, userId = _ref.userId;
              userPayload = {
                cursorName: userName
              };
              _context.prev = 2;
              setLoading(true);
              _context.next = 6;
              return fetch("".concat(BASE_URL, "/whiteboard/join"), {
                method: 'POST',
                headers: {
                  'content-type': 'application/json'
                },
                body: JSON.stringify({
                  roomId: meetingId
                })
              }).then(function (res) {
                if (res.ok) {
                  return res.json();
                } else {
                  throw new Error('join whiteboard error');
                }
              });

            case 6:
              res = _context.sent;
              plugins = createPlugins({
                audio2: audioPlugin2,
                video2: videoPlugin2,
                controllableVideo: controllableVideoPlugin
              });
              plugins.setPluginContext('audio2', {
                identity: role === 'teacher' ? 'host' : ''
              });
              plugins.setPluginContext('video2', {
                identity: role === 'teacher' ? 'host' : ''
              });
              deviceType = DeviceType;
              deviceType = DeviceType.Surface;
              _res$data = res.data, appIdentifier = _res$data.appIdentifier, boardId = _res$data.boardId, boardToken = _res$data.boardToken, boardRegion = _res$data.boardRegion;
              whiteWebSdk = new WhiteWebSdk({
                appIdentifier: appIdentifier,
                region: boardRegion,
                plugins: plugins,
                deviceType: deviceType,
                invisiblePlugins: [IframeBridge],
                wrappedComponents: [IframeWrapper],
                useMobXState: true
              });
              hotKeys = _objectSpread2(_objectSpread2({}, DefaultHotKeys), {}, {
                changeToSelector: 's',
                changeToLaserPointer: 'z',
                changeToPencil: 'p',
                changeToRectangle: 'r',
                changeToEllipse: 'c',
                changeToEraser: 'e',
                changeToText: 't',
                changeToStraight: 'l',
                changeToArrow: 'a',
                changeToHand: 'h'
              });
              options = {
                uid: userId,
                uuid: boardId,
                roomToken: boardToken,
                cursorAdapter: cursorAdapter,
                floatBar: true,
                userPayload: userPayload,
                disableNewPencil: false,
                hotKeys: hotKeys
              };

              if (role === 'student') {
                options.hotKeys = {};
              }

              _context.next = 19;
              return whiteWebSdk.joinRoom(options, {
                onDisconnectWithError: function onDisconnectWithError(error) {
                  setWhiteboardError(error.message);
                },
                onPhaseChanged: function onPhaseChanged(phase) {
                  setWhiteboardPhase(phase);
                },
                onKickedWithReason: function onKickedWithReason(error) {
                  setWhiteboardError(error);
                }
              }).then(function (room) {
                if (room) {
                  room.setMemberState({
                    textSize: 48
                  });
                  setService(room);
                  cursorAdapter.setRoom(room);
                }
              });

            case 19:
              _context.next = 24;
              break;

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](2);
              setWhiteboardError(_context.t0.message);

            case 24:
              _context.prev = 24;
              setLoading(false);
              return _context.finish(24);

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 21, 24, 27]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), []);

  var addPage = function addPage() {
    if (!service) return;
    var activeIndex = service.state.sceneState.index;
    var newSceneIndex = activeIndex + 1;
    var scenePath = service.state.sceneState.scenePath;
    var pathName = createPathName(scenePath);
    service.putScenes(pathName, [{}], newSceneIndex);
    service.setSceneIndex(newSceneIndex);
  };

  useEffect(function () {
    if (!service) return;
    console.info('whiteboard sdk version', service.version);
  }, [service]);
  return {
    service: service,
    joinWhiteboard: joinWhiteboard,
    loading: loading,
    addPage: addPage,
    whiteboardError: whiteboardError,
    whiteboardPhase: whiteboardPhase
  };
};

var WhiteboardProvider = function WhiteboardProvider(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React__default.createElement(Context.Provider, {
    value: useWhiteboardService()
  }, children);
};
var useWhiteboard = function useWhiteboard() {
  return useContext(Context);
};

export { Canvas, CanvasProvider, States as CanvasStates, WhiteboardProvider, useCanvasDispatch, useCanvasState, useWhiteboard };
